<template>
  <div class="status-wrapper">
    <!-- Loading -->
    <div v-if="loading">
      <p>Verifying your payment...</p>
    </div>

    <!-- Success -->
    <div v-else-if="status === 'success'">
      <h2>
        ✅ MiME wallet recharge is successful. Your wallet balance will be updated within
        2–5 minutes.
      </h2>
      <p v-if="transactionId">Transaction ID: {{ transactionId }}</p>
    </div>

    <!-- Failed / Other -->
    <div v-else>
      <h2>❌ {{ remarks || "Payment failed" }} (status: {{ status }})</h2>
      <p>Please try again or contact support.</p>
    </div>

    <router-link to="/wallet/recharge">← Back to Recharge</router-link>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "PaymentStatus",

  data() {
    return {
      loading: true,
      status: "",
      transactionId: "",
      remarks: "",
    };
  },

  async created() {
    const paymentID = this.$route.query.paymentID;
    const queryStatus = this.$route.query.status;

    // ===============================
    // 1. Validate Query Params
    // ===============================
    if (!paymentID || !queryStatus) {
      this.setFailedState("Invalid payment information.");
      return;
    }

    // ===============================
    // 2. Execute bKash Payment
    // ===============================
    try {
      const { data } = await api.post("/api/bkash_pw/execute-payment/", {
        payment_id: paymentID,
      });

      if (data?.success === true) {
        this.status = "success";
        this.transactionId = data.trx_id || "";
      } else {
        this.setFailedState(data?.message || queryStatus || "Payment failed.");
      }
    } catch (err) {
      const errorData = err?.response?.data || {};
      this.setFailedState(
        errorData.error || errorData.details || "Payment verification failed."
      );
    } finally {
      this.loading = false;
    }
  },

  methods: {
    setFailedState(message) {
      this.status = "failed";
      this.remarks = message;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.status-wrapper {
  padding: 40px;
  text-align: center;
  font-size: 22px;
}

.status-wrapper h2 {
  margin-bottom: 16px;
}

.status-wrapper a {
  display: inline-block;
  margin-top: 24px;
  font-size: 16px;
}
</style>
